<template>
  <Panel2 class="Sidebar">
    <slot></slot>
  </Panel2>
</template>

<script>

import Panel2 from '@/legacy/components/widgets/Panel2';

export default {
  components: {
    Panel2
  }
}

</script>

<style lang="scss">
  .Sidebar {
    position: sticky;
    top: 90px;
    min-width: 328px;
    background:
      asset('background/card-6.png')               no-repeat,
      asset('background/card-6-repeat.png') center repeat-y;
  }

  .Sidebar a {
    display: block;
    padding: .7rem 0;
    font-size: 1.6rem;
  }

  .Scrollbar {
    margin-bottom: 20px;
  }

  .Scrollbar a {
    font-size: 1.3rem;
    padding: .4rem 0;
    padding-left: 2rem;
  }
</style>